export type ExcelParserValidationError<ColumnTypes extends Record<string, unknown>> = {
    cellAddress: string | null;
    columnName: keyof ColumnTypes | null;
    type: ExcelParserValidationErrorType | ExcelParserCustomValidationType | string;
    value: string | string[] | number | null;
    worksheetName: string | null;
};

export enum ExcelParserValidationErrorType {
    columnsNotFound = 'columnsNotFound',
    invalidInputBuffer = 'invalidInputBuffer',
    unknown = 'unknown',
    worksheetAlreadyExists = 'worksheetAlreadyExists',
    worksheetNotFound = 'worksheetNotFound',
}

export enum ExcelParserCustomValidationType {
    excelContainsMultiplePatientsWithSameBsn = 'excelContainsMultiplePatientsWithSameBsn',
    groupWithIdentificationNumberNotFound = 'groupWithIdentificationNumberNotFound',
    groupWithNameNotFound = 'groupWithNameNotFound',
    invalidAgbCodeFormat = 'invalidAgbCodeFormat',
    invalidFile = 'invalidFile',
    multipleGroupsWithSameNameFound = 'multipleGroupsWithSameNameFound',
    multipleOrganizationsWithSameAgbCodeFound = 'multipleOrganizationsWithSameAgbCodeFound',
    organizationWithAgbCodeNotFound = 'organizationWithAgbCodeNotFound',
    vipLiveCareGroupExternalReferenceNumberNotFound = 'vipLiveCareGroupExternalReferenceNumberNotFound',
    vipLiveReferralDateOlderThanOneYear = 'vipLiveReferralDateOlderThanOneYear',
}
